import gql from 'graphql-tag';

import type { UtilityContext } from '@change/core/react/utilityContext';

import type { PetitionDetailsPageStatsQuery, PetitionDetailsPageStatsQueryVariables } from './stats.graphql';

export type QueryVariables = {
	petitionSlugOrId: string;
	maxSigners: number;
	shouldFetchRecruiter: boolean;
	recruiterId: string;
};

export type PetitionStats = NonNullable<PetitionDetailsPageStatsQuery['petitionStats']>;

const QUERY = gql`
	query PetitionDetailsPageStats($petitionSlugOrId: String!) {
		petitionStats: petitionBySlugOrId(slugOrId: $petitionSlugOrId) {
			id
			signatureState {
				signatureCount {
					displayed
					displayedLocalized
				}
				signatureGoal {
					displayed
					displayedLocalized
				}
				signatureTargetLocalized
			}
		}
	}
`;

export async function getPetitionStats(
	petitionSlugOrId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionStats | undefined> {
	const { data } = await fetch<PetitionDetailsPageStatsQuery, PetitionDetailsPageStatsQueryVariables>({
		query: QUERY,
		variables: {
			petitionSlugOrId,
		},
	});
	if (!data?.petitionStats) {
		return undefined;
	}
	return data.petitionStats;
}
